module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-bibliographie__page--wrapper"
  }, [_c('div', {
    staticClass: "ksm-bibliographie__page"
  }, [_c('div', {
    staticClass: "ksm-bibliographie__content"
  }, _vm._l((_vm.bibliographie), function(bibl, key) {
    return _c('div', {
      key: key,
      staticClass: "ksm-bibliographie__categorie"
    }, [_c('div', {
      staticClass: "__title"
    }, [_vm._v(_vm._s(_vm.titles[key]))]), _vm._v(" "), _c('div', {
      staticClass: "__body"
    }, [_vm._l((bibl), function(p, i) {
      return [_c('div', {
        key: 'p' + i,
        staticClass: "ksm-bibliographie__item",
        class: _vm.keyitem == p.keyitem.toLowerCase() ? 'active' : '',
        attrs: {
          "data-keyitem": _vm.getKeyItem(p, this)
        }
      }, [_c('div', {
        staticClass: "__subtitle"
      }, [_vm._v("[" + _vm._s(p.shorttitle) + "]")]), _vm._v(" "), _c('div', {
        staticClass: "__content",
        domProps: {
          "innerHTML": _vm._s(p.bib)
        }
      })])]
    })], 2)])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4089fdce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Bibliographie.vue
// module id = 1970
// module chunks = 1